import { OrderByInput } from '../common/orderByInput';
import { PaginationInput } from '../common/paginationInput';
import { LeadFilter } from './leadFilter';

export class GetLeadsInput {
  id: any;
  paginationInput: PaginationInput;
  orderBy: OrderByInput;
  filter: LeadFilter;
  isDownloadCsv?: boolean;

  constructor(paginationInput: PaginationInput, filter: LeadFilter) {
    this.paginationInput = paginationInput;
    this.filter = filter;
  }
}
